import "../scss/main.scss";
import WooFilterComponent from "./components/woo-filter-component.js";

document.addEventListener("DOMContentLoaded", () => {
  const wooFilterComponent = new WooFilterComponent();
  wooFilterComponent.run();
});
